import { SHIPTRACK } from "../../actions/portal";

export default function(state = [], action) {
  switch (action.type) {
    case SHIPTRACK:
      return action.payload;
  }
  return state;
}
